<template>
  <BaseModal
    :is-open="modal.isDisplayed"
    :icon="modal.icon"
    icon-color="green"
    :link-text="modal.linkText"
    :text-title="modal.title"
    :text="modal.text"
    @click="modalConfirmed()"
  />
</template>

<script>
import { BaseModal } from '@/ui/dialog'
export default {
  components: {
    BaseModal
  },
  data: () => {
    return {
      modal: {
        isDisplayed: false,
        linkText: '',
        title: '',
        text: '',
        icon: 'HeroCheckIconSolid'
      }
    }
  },
  mounted() {
    this.initPartnerConfirmModal()
  },
  methods: {
    initPartnerConfirmModal() {
      if (this.$route.query.confirmType && this.$route.query.partner) {
        if (this.$route.name === 'TabletList') {
          this.modal.isDisplayed = true
          this.modal.linkText = this.$t('global.partner.linkText')
          this.modal.title = this.$t('global.partner.title')
          this.modal.text = this.$t(`global.partner.text.${this.$route.query.partner}`)
        } else {
          this.$router.push({
            name: 'TabletList',
            query: {
              confirmType: 'partner',
              partner: this.$route.query.partner
            }
          })
        }
      }
    },
    modalConfirmed() {
      this.modal.isDisplayed = false
      this.$router.replace({ query: {} })
    }
  }
}
</script>

<style></style>
